import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { StripeService } from './stripe.service';

angular.module('app-lite.stripe', [])
  .service('stripeApi', downgradeInjectable(StripeService));
